import * as dayjs from 'dayjs';
import {ContactField} from "./contact-field";

export class ContactFieldPreset {

    id: string;
    name: string;
    modified: dayjs.Dayjs;
    created: dayjs.Dayjs;
    contact_fields: ContactField[];

    constructor() {
    }

    static fromJSON(json: ContactFieldPresetJSON | string): ContactFieldPreset {
        if (typeof json === 'string') {
            return JSON.parse(json, ContactFieldPreset.reviver);
        } else {
            const contactFieldPreset = Object.create(ContactFieldPreset.prototype);

            const extra = {
                modified: dayjs(json.modified),
                created: dayjs(json.created),
                contact_fields: []
            };

            Object.keys(json).forEach((key, _) => {
                if (key === 'contact_fields') {
                    json[key].forEach((value, _) => {
                        extra[key].push(ContactField.fromJSON(value));
                    });
                }
            });

            return Object.assign(contactFieldPreset, json, extra);
        }
    }

    static reviver(key: string, value: any): any {
        return key === "" ? ContactFieldPreset.fromJSON(value) : value;
    }

    addContactField(contactField: ContactField): void {
        this.contact_fields.push(ContactField.fromJSON({
            id: contactField.id,
            name: contactField.name
        }));
    }

    removeContactField(contactField: ContactField): void {
        let index = this.contact_fields.findIndex((element) => {
            return element['id'] === contactField.id;
        });

        if (index >= 0) {
            this.contact_fields.splice(index, 1);
        }
    }

    hasContactField(contactField: ContactField): boolean {
        let index = this.contact_fields.findIndex((element) => {
            return element['id'] === contactField.id;
        });

        return index >= 0;
    }
}

// A representation of ContactFieldPreset data that can be converted to
// and from JSON without being altered.
interface ContactFieldPresetJSON {
    id?: string;
    name?: string;
    modified?: dayjs.Dayjs;
    created?: dayjs.Dayjs;
}
